export default {"src":"/_next/static/media/HamburgerIcon.4da308f7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};